import * as React from 'react';

export default () =>(
  <svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 30 63'>
    <path d='M30,53.4l-6.2,4l2.2-7.2H30V47h-2.8l2.8-9V27.5l0,0l-7.3-12.8V7.4l7.3,9.9V12l-7.3-9.9L21.1,0l-1.5,2L7.1,18.7l-0.3,0.4	l-0.3,0.3L6.2,21L0.5,46.9L0,49.3l0.9,0.6l0.5,0.4L5,52.6L21,63l9-5.8V53.4z M19.4,7.4v7.4l-7.3,12.9l-2.3-7.3L19.4,7.4z M8.3,26.2	l1.7,5L5.6,39L8.3,26.2z M4.5,47l6.8-11.7L15,47H4.5z M7.1,50.2h8.8l2.3,7.1L7.1,50.2z M21.1,55.8l-1.8-5.5h3.5L21.1,55.8z M18.3,47	l-4.9-15.4L21,18.2l7.6,13.4L23.7,47H18.3z' />
  </svg>
)
